import React from 'react';

export default function Our({ x }) {
  return (
    <>
      <div className=" font-sans text-3xl font-normal mx-8 mb-1 sm:mx-28 mt-6 text-gray-100">
        Our {x}
      </div>
      <hr className=" bg-black h-0.5   mx-5 sm:mx-24 " />
    </>
  );
}
